import { render, staticRenderFns } from "./detail-download.vue?vue&type=template&id=7d91f7c2&scoped=true"
import script from "./detail-download.vue?vue&type=script&lang=js"
export * from "./detail-download.vue?vue&type=script&lang=js"
import style0 from "./detail-download.vue?vue&type=style&index=0&id=7d91f7c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d91f7c2",
  null
  
)

export default component.exports